import React, { useState } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";

interface ExportUserProps {
  data: any[];
}

const ExportUser: React.FC<ExportUserProps> = ({ data }) => {
  const [open, setOpen] = useState(false);
  const [limit, setLimit] = useState<number>(10);
  const [format, setFormat] = useState<"excel" | "pdf" | null>(null);

  const handleExport = () => {
    const exportData = data.slice(0, limit).map((item, index) => ({
      No: index + 1,
      Nama: item.name,
      Email: item.email,
      "No Telepon": item.no_tlpn || "-",
      "Tanggal Daftar": item.created_at
        ? new Date(item.created_at).toLocaleDateString("id-ID", {
            day: "2-digit",
            month: "long",
            year: "numeric",
          })
        : "-",
    }));

    if (format === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "User");
      XLSX.writeFile(workbook, "Data_Pengguna.xlsx");
    } else if (format === "pdf") {
      const doc = new jsPDF();
      doc.setFontSize(12);
      doc.text("Daftar Pengguna", 14, 15);
      let y = 30;
      exportData.forEach((item: any) => {
        doc.text(`${item.No}. ${item.Nama} | ${item.Email} | ${item["No Telepon"]} | ${item["Tanggal Daftar"]}`, 14, y);
        y += 8;
      });
      doc.save("Data_Pengguna.pdf");
    }
    setOpen(false);
  };

  return (
    <>
      {/* Tombol utama */}
      <button onClick={() => setOpen(true)} className="bg-primary text-white px-4 py-2 rounded hover:bg-yellow-600">
        Export
      </button>

      {/* Modal Popup */}
      {open && (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-xl shadow-lg w-[90%] max-w-md">
            <h2 className="text-xl font-semibold mb-4 text-center">Export Data Pengguna</h2>

            <label className="block text-sm mb-2 text-center">Jumlah data yang akan di-export:</label>
            <input type="number" min={1} max={data.length} value={limit} onChange={(e) => setLimit(Number(e.target.value))} className="border rounded-lg w-full px-3 py-2 text-center mb-2" />

            <p className="text-center text-gray-500 text-sm mb-4">Total tersedia: {data.length} data</p>

            <div className="flex justify-center gap-3 mb-5">
              <button onClick={() => setFormat("excel")} className={`px-4 py-2 rounded font-medium ${format === "excel" ? "bg-green-600 text-white" : "bg-green-100 text-green-700"}`}>
                Excel
              </button>
              <button onClick={() => setFormat("pdf")} className={`px-4 py-2 rounded font-medium ${format === "pdf" ? "bg-red-600 text-white" : "bg-red-100 text-red-700"}`}>
                PDF
              </button>
            </div>

            <div className="flex justify-end gap-3 mt-10">
              <button onClick={() => setOpen(false)} className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300">
                Batal
              </button>
              <button disabled={!format} onClick={handleExport} className={`px-4 py-2 rounded ${format ? "bg-yellow-500 hover:bg-yellow-600 text-white" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}>
                Export
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ExportUser;
